import GridKeikkaEditor_Teksti_Row from "../../teksti/GridKeikkaEditor_Teksti_Row";
import PropTypes from "prop-types";

export default function GridKeikkaEditor_Teksti_Tyomaa({ subText, keikkaState }) {
  return (
    <GridKeikkaEditor_Teksti_Row title="Työmaa" phone={keikkaState?.personPhone}>
      {subText(keikkaState?.tyomaaNimi)}
      {subText(keikkaState?.tyomaaOsoite1)}
      {subText(keikkaState?.tyomaaOsoite2)}
      {subText(keikkaState?.tyomaaOsoite3)}
      {subText(keikkaState?.tyomaaOsoite4)}
      {subText(keikkaState?.personFirstName + " " + keikkaState?.personLastName)}{" "}
    </GridKeikkaEditor_Teksti_Row>
  );
}

GridKeikkaEditor_Teksti_Tyomaa.propTypes = {
  subText: PropTypes.func,
  keikkaState: PropTypes.object,
};
